
import { useState } from "react";


const FAQ = ({ faqData }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="w-full mx-auto">
      {faqData.map((item, index) => (
        <div
          className={`mb-4 border-b-2 border-gray-200 overflow-hidden transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]`}
          key={index}
        >
          <div
            className={`flex justify-between items-center p-4 md:p-5 cursor-pointer transition-colors duration-300 `}
            onClick={() => toggleFAQ(index)}
          >
            <h3 className="text-lg font-semibold ">{item.question}</h3>
            <img
              src="https://d5ik1gor6xydq.cloudfront.net/websiteImages/creatorMarketplace/plus.svg"
              alt="toggle icon"
              className={`w-5 h-5 transition-transform duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]`}
              width={32}
              height={32}
            />
          </div>
          <div
            className={`grid transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${
              activeIndex === index ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
            }`}
          >
            <div className="overflow-hidden">
              <div className="p-4 md:p-6 pt-0">
                {/* <p className="text-gray-600 leading-relaxed text-justify">{item.answer}</p> */}

                {typeof item.answer === "string" ? (
                  <div
                    className="text-gray-600 leading-relaxed text-justify"
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                ) : (
                  item.answer
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
